import { createSelector } from 'reselect';

const selectDbas = (state: any) => state.dbas;


export const selectDbasCurrentItem = createSelector([selectDbas], (dbas) => dbas.current);

export const selectDbasListItems = createSelector([selectDbas], (dbas) => dbas.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectDbasListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectDbasQueryItems = createSelector([selectDbas], (dbas) => dbas.query);

export const selectDbasCreatedItem = createSelector([selectDbas], (dbas) => dbas.create);

export const selectDbasUpdatedItem = createSelector([selectDbas], (dbas) => dbas.update);

export const selectDbasReadItem = createSelector([selectDbas], (dbas) => dbas.read);

export const selectDbasDeletedItem = createSelector([selectDbas], (dbas) => dbas.delete);

export const selectDbasSearchedItems = createSelector([selectDbas], (dbas) => dbas.search);

export const selectDbasItemsCount = createSelector([selectDbas], (dbas) => dbas.count);

export const selectDbasItemsFilter = createSelector([selectDbas], (dbas) => dbas.filter);